import { makeActionCreator } from '../../config/store/utils'
import { getPurchasingMechanisms } from '../../services/contingencies'

export const GET_PURCHASING_MECHANISMS = 'GET_PURCHASING_MECHANISMS'
export const GET_PURCHASING_MECHANISMS_ERROR = 'GET_PURCHASING_MECHANISMS_ERROR'
export const GET_PURCHASING_MECHANISMS_SUCCESS = 'GET_PURCHASING_MECHANISMS_SUCCESS'
export const onGetPurchasingMechanisms = makeActionCreator(GET_PURCHASING_MECHANISMS)
export const onGetPurchasingMechanismsError = makeActionCreator(GET_PURCHASING_MECHANISMS_ERROR, 'payload')
export const onGetPurchasingMechanismsSuccess = makeActionCreator(GET_PURCHASING_MECHANISMS_SUCCESS, 'payload')
export const onGetPurchasingMechanismsThunk = payload => async dispatch => {
  dispatch(onGetPurchasingMechanisms())

  try {
    const { data = {} } = await getPurchasingMechanisms({
      year: payload.year,
      contingencyId: payload.contingencySelected
    })
    const categories = data?.payload?.map(datum => datum.name)
    const csv = [
      ['Mecanismo de compra', 'Nº de órdenes de compra', 'Monto total', 'Monto total (USD)'],
      ...data?.payload?.map(datum => [datum.name, datum.orders, datum.amount, datum.amountUSD])
    ]

    return dispatch(onGetPurchasingMechanismsSuccess({ categories, csv, data: data?.payload }))
  } catch (error) {
    return dispatch(onGetPurchasingMechanismsError({ error }))
  }
}
